export const serviciosArray = [
	{
		"nombre": 'Marco Normativo',
		"anio": [
			{
				"number": '2023',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2022',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2021',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2020',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},
		]
	},{
		"nombre": 'COCODI',
		"anio": [
			{
				"number": '2023',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2022',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2021',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2020',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},
		]
	},{
		"nombre": 'Sesiones Comité',
		"anio": [
			{
				"number": '2023',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2022',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2021',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},{
				"number": '2020',
				"datos": [
					{
						"nombre": 'nombre 1',
						"pdf": 'https://transparencia.hidalgo.gob.mx',
						"xlsx": 'https://transparencia.hidalgo.gob.mx',
					},
				]
			},
		]
	}
];